// @flow

import React, { Component } from 'react';
import type { Element } from 'react';
import styled from 'styled-components';

import theme from '../../themes';
import { ModalContainer } from './modal';

type Props = {
  id: string,
  children: string | Element<*> | Array<Element<*>>;
  in: boolean;
};

const Modal = styled.div`
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 65535;
  display: ${({ show }) => show ? 'block' : 'none'};
  ${theme.Modal};
  background-color: rgba(0, 0, 0, .4);
`;

const SmallModal = styled.div`
  background-color: white;
  box-sizing: border-box;
  margin: 0 auto;
  max-height: 80%;
  overflow-y: auto;
  padding: 24px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  width: 85%;
  z-index: 65536;

  h2 {
    color: inherit;
    font-family: inherit;
    font-size: 20px;
    margin: 0;
    padding: 0 0 16px;
  }

  .section-body {
    border: none;
  }

  .content-block {
    padding: 0;
  }

  .smart-button {
    font-size: 16px;
    float: right;
    width: inherit;
    text-transform: uppercase;
    color: #2ab7be;
  }

  .section-body {
    border: none;
  }
`;

export default class extends Component<Props, void> {
  overlayClick = (event) => {
    event.preventDefault();
    if (event.currentTarget === event.target) {
      this.props.onToggleView();
    }
  }

  render() {
    const { id, show, children } = this.props;

    return (
      <ModalContainer id={id}>
        <Modal
          onClick={this.overlayClick}
          show={show}
        >
          <SmallModal>
            {children}
          </SmallModal>
        </Modal>
      </ModalContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/small-modal.js